import { IWhistleBlowCategoryEditItem, WhistleBlowCategoryEditItem } from "./whistleBlowCategoryEditItem";

export interface IWhistleBlowCategoryEdit {
    familiarization: IWhistleBlowCategoryEditItem;
}

export class WhistleBlowCategoryEdit implements IWhistleBlowCategoryEdit {
    familiarization: WhistleBlowCategoryEditItem;

    constructor();
    constructor(obj: IWhistleBlowCategoryEdit);
    constructor(obj?: any) {
        this.familiarization = new WhistleBlowCategoryEditItem(obj ? obj.familiarization : null);
    }
}